import { Link, generatePath } from 'react-router-dom';
import { AppRoutes } from '@/constants/routes';
import { UserAvatar } from '@/components/NavigationBar/UserAvatar';

interface MemberCellProps {
    userId: string;
    displayName: string;
}

export function MemberCell({ userId, displayName }: MemberCellProps) {
    return (
        <Link
            to={generatePath(AppRoutes.SETTINGS_MEMBER, { userId })}
            className="flex items-center gap-2.5 text-sm text-grey-100 hover:text-white-100"
        >
            <UserAvatar name={displayName} size="sm" />
            <span>{displayName}</span>
        </Link>
    );
}
